var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { styled } from '../styled';
var gridTemplateColumns = {
    '1/2 1/2': 'repeat(2, minmax(0,1fr))',
    '1/3 1/3 1/3': 'repeat(3, minmax(0,1fr))',
    '2/3 1/3': 'minmax(0,2fr) minmax(0,1fr)',
    '1/3 2/3': 'minmax(0,1fr) minmax(0,2fr)',
    '1/4 1/4 1/4 1/4': "repeat(4, minmax(0,1fr))",
    '2/4 1/4 1/4': 'minmax(0,2fr) minmax(0,1fr) minmax(0,1fr)',
    '1/4 2/4 1/4': 'minmax(0,1fr) minmax(0,2fr) minmax(0,1fr)',
    '1/4 1/4 2/4': 'minmax(0,1fr) minmax(0,1fr) minmax(0,2fr)',
    '3/4 1/4': 'minmax(0,3fr) minmax(0,1fr)',
    '1/4 3/4': 'minmax(0,1fr) minmax(0,3fr)',
};
var Root = styled('div', {
    name: 'QuantumColumnLayout',
    slot: 'Root',
})({
    display: 'grid',
});
export var ColumnLayout = React.forwardRef(function (_a, ref) {
    var component = _a.component, asProp = _a.as, _b = _a.gutter, gutter = _b === void 0 ? 3 : _b, _c = _a.distribution, distribution = _c === void 0 ? '1/2 1/2' : _c, children = _a.children, sx = _a.sx, rootProps = __rest(_a, ["component", "as", "gutter", "distribution", "children", "sx"]);
    return (React.createElement(Root, __assign({ as: asProp || component || 'div', ref: ref, sx: __assign({ gridTemplateColumns: ['minmax(0,1fr)', 'minmax(0,1fr)', gridTemplateColumns[distribution]], gap: gutter }, sx) }, rootProps), children));
});
